import React from 'react';
import PropTypes from 'prop-types';
import Cell from '@/components/Cell';
import CellItem from '@/components/CellItem';
import Button from '@/components/Button';
import Minus from '@/assets/minus.svg';
import Plus from '@/assets/plus.svg';
import useStyle from './style';
import cx from '@/utils/cx';


const NumberStepper = ({
  validation,
  formatter,
  value,
  min,
  max,
  step,
  onChange,
  buttonsProps,
  className,
  _size = 'xs',
  /**
   * Only if you need custom renderer for middle section, pass children.
   * */
  children,
  ...rest
}) => {
  const classes = useStyle();

  const handleClickButton = (action = '+') => (e) => {
    e.preventDefault();
    const calculatedValue = value + ((action === '+' ? 1 : -1) * step);
    const newValue = calculatedValue > max ? max : (calculatedValue < min ? min : calculatedValue);
    onChange(newValue);
  };

  const localButtonsProps = (action = '+') => {
    const icons = {
      '+': (<Plus />),
      '-': (<Minus />),
    };
    const ret = {
      className: 'button minus',
      onClick: handleClickButton(action),
      _size,
      invert: true,
      fab: true,
      _color: 'text',
      _border: 'md',
      _radius: 'md',
      _text_weight: 'bold',
      children: icons[action],
    };
    if (action === '+' && typeof max === 'number' && value >= max) {
      ret.disabled = true;
    } else if (action === '-' && typeof min === 'number' && value <= min) {
      ret.disabled = true;
    }
    return Object.assign(ret, buttonsProps);
  };

  return (
    <div
      className={cx(classes.numberStepper, className)}
      _dir="ltr"
      {...rest}
    >
      <Cell>
        <CellItem>
          <Button {...localButtonsProps('-')} />
        </CellItem>
        <CellItem grow className="center-part">
          {children && children}
          {!children && (
            <div _text_align="center">
              {value}
            </div>
          )}
        </CellItem>
        <CellItem>
          <Button {...localButtonsProps('+')} />
        </CellItem>
      </Cell>
    </div>
  );
};

NumberStepper.propTypes = {
  value: PropTypes.number,
  min: PropTypes.number,
  max: PropTypes.number,
  step: PropTypes.number,
  onChange: PropTypes.func,
  buttonsProps: PropTypes.object,
  /**
   * Only if you need custom renderer for middle section, pass children.
   * */
  children: PropTypes.any,
};

NumberStepper.defaultProps = {
  value: 0,
  min: undefined,
  max: undefined,
  step: 5,
  onChange: () => {},
  buttonsProps: {},
  children: null,
};

export default NumberStepper;
